<div class="container">
  <div>
    <div class="select-form" *ngIf="state.userHasMinType(1)">
      <lib-user-picker
        [users]="this.state.users$"
        [showAllEntry]="true"
        (selectedUserChanged)="userChange($event)"
      ></lib-user-picker>
    </div>

    <div class="select-form">
      <lib-month-picker
        style="width: 100%"
        (selectedValueChanged)="monthChange($event)"
        (selectedYearChanged)="yearChange($event)"
        [showAllEntry]="true"
      ></lib-month-picker>
    </div>
    <div class="small-margin">
      <ion-button
        (click)="modalService.openAbsenceFormModal(null, selectedWorker)"
        ><ion-icon slot="start" size="small" color="light" name="add"></ion-icon
        >Neue Abwesenheit
      </ion-button>
      @if(selectedEntriesValid){
      <ion-button color="danger" (click)="delete()"
        ><ion-icon
          slot="start"
          size="small"
          color="light"
          name="trash-outline"
        ></ion-icon
        >Löschen
      </ion-button>
      }
    </div>

    <div class="custom-table">
      <div class="row header">
        <div class="col">
          <ion-checkbox
            [checked]="allSelected"
            (ionChange)="toggleAll()"
            (click)="$event.stopPropagation()"
          ></ion-checkbox>
        </div>
        <div class="col" style="display: flex; align-items: center">
          Datum
          <ion-icon
            size="small"
            style="color: black; cursor: default"
            name="caret-down-outline"
          ></ion-icon>
        </div>
        <div class="col grow">Name</div>
        <div class="col">Typ</div>
        <div class="col"></div>
      </div>

      <div
        class="row"
        *ngFor="let wd of filteredEntries"
        (click)="modalService.openAbsenceDetailModal(wd.id)"
      >
        <div
          class="col"
          (click)="$event.stopPropagation(); toggleSelection(wd)"
        >
          <ion-checkbox
            [checked]="isSelected(wd)"
            (click)="$event.stopPropagation()"
            (ionChange)="toggleSelection(wd)"
          ></ion-checkbox>
        </div>
        <div class="col">
          {{ wd.date | date : "dd.MM.yyyy" }}
        </div>
        <div class="col grow">
          {{ state.getUserDisplayNameAsync(wd.user) | async }}
        </div>
        <div class="col">{{ wd.type }}</div>
        <div class="col">
          <ion-icon
            *ngIf="wd.approvedBy"
            style="color: rgb(0, 179, 0)"
            size="small"
            name="checkmark-circle-outline"
          ></ion-icon>

          <ion-icon
            *ngIf="!wd.approvedBy && !wd.rejectedBy"
            style="color: rgb(255, 174, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
          <ion-icon
            *ngIf="wd.rejectedBy"
            style="color: rgb(228, 0, 0)"
            name="close-circle-outline"
          ></ion-icon>
        </div>
      </div>
    </div>
  </div>
  <lib-table-legend [items]="[0, 1, 7]"></lib-table-legend>
</div>
